import { useLang } from "../i18n";

export const Marquee = () => {
    const { t } = useLang();
    const ITEMS = t("marquee.items");
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-brass/15 bg-onyx/60 py-5 select-none"
            aria-hidden="true"
        >
            <div className="flex w-max animate-marquee whitespace-nowrap">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="font-serif italic text-lg sm:text-xl text-stone-400 px-6">
                                    {item}
                                </span>
                                <span className="text-brass/60 text-xs">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
